$(document).ready(function() { 

var vitemcnt = 3.4;
        var vpageDots = true;
        if (matchMedia('screen and (max-width: 480px)').matches) {
            vitemcnt = 1.2;
            vpageDots = true;
        } else if (matchMedia('screen and (max-width: 1030px)').matches) {
            vitemcnt = 2.6;
        }
     
        $(".commoncarousel").each(function(index) {
            var vprevNextButtons = true;
            $(this).removeClass('carouselftalign');
            if ($(this).find('.carousel-cell').length <= Number($(this).attr('data-showele'))) {
                vprevNextButtons = false;
                $(this).addClass('carouselftalign');
            }
            var vGroup = false;
            if ($(this).attr('data-group') == 'true') {
                vGroup = true;
            }
          var $ele = $(this);
           $ele.on( 'ready.flickity', function() {      
               if($ele.find('.flickity-prev-next-button.previous').prop('disabled') && $ele.find('.flickity-prev-next-button.next').prop('disabled'))
               {
                 $ele.addClass('slider_left_align');
               }
            });
            if ($(this).attr('data-dots') == 'false') {
                vpageDots = false;
            }
            var $carousel = $ele.flickity({
                "contain": true,
                "pageDots": vpageDots,
                "groupCells": vGroup,
                "draggable": true,
                "prevNextButtons": vprevNextButtons,
                "percentPosition": true,
                "cellAlign": "center",
               "imagesLoaded": true
            });
          
            var vRange = false;
            var vRangeele;
            if ($(this).hasClass('shopcarousel')) {
                vRange = true;
                vRangeele = $('#shopcarouselrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('getinspiredcarousel')) {
                vRange = true;
                vRangeele = $('#getinspiredcarouselrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('youmayalsocarousel')) {
                vRange = true;
                vRangeele = $('#youmayalsorange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            } else if ($(this).hasClass('otherprodcarousel')) {
                vRange = true;
                vRangeele = $('#otherprodrange');
                vRangeele.attr('max', $(this).find('.flickity-page-dots li').length - 1);
            }
            if (vRange) {
                vRangeele.on('input', function() {
                    var newval = $(this).val();
                    $carousel.flickity('select', newval);
                });
                $carousel.on('select.flickity', function() {
                    vRangeele.val($carousel.data('flickity').selectedIndex);
                });
            } 

        
        });

});

var vMobilesize = 841;
var vyourinspcnt = 11;
var vTimer;
var configtabanim = "0px";
var configtabclick = 0;
var cammiejs = {

 homeinspipopupclose: function(obj) {

        $(obj).closest('.gics_popup').removeClass('active');
    },
    homeinspipopup: function(obj, hdn, img, name, bigimg) {
        var vobjWidth = $(obj).closest('.gics_img').width();
        var vobjHeight = $(obj).closest('.gics_img').height();
        var vele = $(obj).closest('.gici_point').next('.gics_popup');
        vele.addClass('active');
        var vpopobjWidth = vele.outerWidth(true);
        var vpopobjHeight = vele.outerHeight(true);
        vele.find('h4').html(hdn);
        vele.find('img').attr('src', img).attr('data-bigurl', bigimg);
        vele.find('p').html(name);
        var vleft = $(obj).position().left + $(obj).outerWidth(true);
        if ((vleft + vpopobjWidth) > vobjWidth) {
            vleft = $(obj).position().left - vpopobjWidth;
        }
        var vtop = $(obj).position().top + $(obj).outerHeight(true);
        if ((vtop + vpopobjHeight) > vobjHeight) {
            vtop = $(obj).position().top - vpopobjHeight;
            if (vtop < 0) {
                vtop = 0;
            }
        }
        vele.css({
            'left': vleft,
            "top": vtop
        });
    }
};